export const STATUS = {
    CONNECTING: 'connecting',
    CONNECTED: 'connected',
    DISCONNECTED: 'disconnected',
    RETRYING: 'retrying',
    ERROR: 'error',
    AWAITING_RESPONSE: 'awaiting-response',
    AWAITING_USER_RESPONSE: 'awaiting-response'
};

export const EVENT_TYPES = {
    CONNECTION: 'connection',
    MESSAGE: 'message',
    HEARTBEAT: 'heartbeat'
};

export const MESSAGE_TYPES = {
    NEW_CONNECTION_REQUEST: 'NEW_CONNECTION_REQUEST',
    USER_QUERY: 'USER_QUERY',
    USER_PING: 'USER_PING',
    USER_QUERY_RESPONSE: 'USER_QUERY_RESPONSE',
    PRODUCTS_RESPONSE: 'PRODUCTS_RESPONSE'
};

export const MESSAGE_ROLES = {
    USER: 'user',
    ASSISTANT: 'assistant'
};

export const RESPONSE_TYPES = {
    CAMPAIGN_CONFIG_RESPONSE: 'CAMPAIGN_CONFIG_RESPONSE',
    FOLLOW_UP_MESSAGES_RESPONSE: 'FOLLOW_UP_MESSAGES_RESPONSE',
    PRODUCT_RECOMMENDATION_RESPONSE: 'PRODUCTS_RESPONSE',
    PONG_RESPONSE: 'PONG_RESPONSE',
    FEEDBACK_COLLECTION: 'FEEDBACK_COLLECTION',
    CONTEXTUAL_DIVIDER: 'CONTEXTUAL_DIVIDER'
};

export const ENTRYPOINTS = {
    PDP: 'PDP',
    PLP: 'PLP',
    SRP: 'SRP',
    DEFAULT: 'default'
};

export const ERROR_CODES = {
    ABNORMAL_CLOSURE: 1006
};

export const STD_BASKET_TYPE = 'Standard';

export const PRODUCT_RECOMMENDATION_ANALYTICS_CONTEXT = 'productRecommendation';

export const PRODUCT_RECOMMENDATION_ANALYTICS_CATEGORY = 'ai-recommendation';

export const BIRTHDAY_REWARD_ANALYTICS_CONTEXT = 'birthdayReward';

export const BIRTHDAY_REWARD_ANALYTICS_CATEGORY = 'ai-birthday-reward';

export const REWARDS_BAZAAR_ANALYTICS_CONTEXT = 'rewardsBazaar';

export const REWARDS_BAZAAR_ANALYTICS_CATEGORY = 'ai-rewards-bazaar';

export const REWARD_TYPES = {
    BIRTHDAY: 'birthday',
    REWARDS_BAZAAR: 'rewardsBazaar'
};

export const REWARD_FALLBACK_URLS = {
    birthday: '/beauty/birthday-gift',
    rewardsBazaar: '/rewards/rewards-bazaar'
};

export const BI_TYPE_BIRTHDAY_GIFT = 'birthday gift';

export const INTENTIONS = {
    GIFT_FINDER: 'GF',
    DEFAULT: 'DEFAULT'
};

export const AB_FEATURES_FLAGS = {
    FRAGRANCE: 'fragrance',
    GIFTS: 'gifts'
};

export const EVENT_DATA_TYPES = {
    USER_HAS_SIGNED_IN: 'USER_HAS_SIGNED_IN_EVENT'
};

export const SIGN_IN_PATH = '/signin';
